// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YLB-7","icon":"styles_icon__2gB_J"};